export type GetHelixSearchResultTotalOnlyReq = {
    searchSessionToken: string
    filterOptions?: FilterOptionsDto
    sortOptions?: SortOptionsDto
}

export type GetHelixSearchResultTotalOnlyRes = {
    totalCount: number
}

// share by all helix search request apis

export enum SortBy {
    booleanSearchScore = 'booleanSearchScore',
    relationshipScore = 'relationshipScore',
    combined = 'combined',
}

export enum SortByDirection {
    asc = 'asc',
    desc = 'desc',
}

export enum ShortlistFilterValues {
    yes = 'yes',
    no = 'no',
    none = 'none',
}

export type SortOptionsDto = {
    sortBy: SortBy
    direction?: SortByDirection
}

export type RoleContextFiltersDto = {
    shortlistedValues?: ShortlistFilterValues[]
}

export type FilterOptionsDto = {
    mustBeInBooleanSearchResults?: boolean
    mustHaveRelationship?: boolean
    networkSeedPersonIds?: string[]
    minRelationshipScore?: number
    roleContextFilters?: RoleContextFiltersDto
}
